module.exports = __webpack_public_path__ + "img/20240918152956578vbs.a1abc2a3.jpg";